var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153 76.5C153 118.75 118.75 153 76.5 153C34.2502 153 0 118.75 0 76.5C0 34.2502 34.2502 0 76.5 0C118.75 0 153 34.2502 153 76.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38.5548H37.054V44.4915L34.8001 44.6774V93.2649L37.054 93.4985V99.2573H26V93.2994H28.5227V44.68L26 44.5048V38.5548Z",
    fill: "#8C9FD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127 109.352H44.4623V27L127 109.352ZM112.463 103.418L50.4045 41.4913V87.068H67.012V103.418H112.463ZM50.3778 103.389H60.8624V93.1215H50.3778V103.389Z",
    fill: "#8C9FD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0218 44.5234L73.7605 45.6916C72.4299 44.2977 71.1393 42.941 69.9419 41.6851L77.4992 34.0173L81.5866 37.8963L79.8489 39.8584L114.522 73.7051L114.198 74.2733L116.09 72.6988L120.161 76.6256L112.38 84.5669L108.346 80.3613L109.897 78.6222L75.0218 44.5234Z",
    fill: "#8C9FD7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7 124.703C60.6442 125.5 60.5936 126.201 60.5377 127H54.8058V116.043H60.5191C60.5963 116.839 60.6654 117.606 60.7479 118.472H109.373C109.461 117.689 109.549 116.929 109.639 116.04H115.371V126.997H109.663C109.591 126.283 109.522 125.585 109.432 124.703H60.7Z",
    fill: "#8C9FD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/math.80f74565deaecd41d8414fe6cc0c64c0.svg";
export { ForwardRef as ReactComponent };